import { Form as AntForm, Radio, RadioChangeEvent } from 'antd';
import { AnySchema } from 'yup';
import { Controller, Control } from 'react-hook-form';
import { formHelpers } from '@helpers/formHelpers';

const { Item: FormItem } = AntForm;

interface HSMSRadioOption {
  label: string;
  value: string;
}

interface HSMSRadioGroupProps {
  label?: string;
  name: string;
  radioOptions: HSMSRadioOption[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  validationSchema?: AnySchema;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any; // If we are setting proper types we need to get the form values. Not possible since we use this in multiple forms
  defaultValue?: string;
}

export const HSMSRadioGroup = ({
  label,
  name,
  radioOptions,
  control,
  validationSchema,
  errors,
  defaultValue,
}: HSMSRadioGroupProps) => (
  <FormItem
    label={label}
    required={validationSchema && formHelpers.isRequired(validationSchema, name)}
    validateStatus={errors && errors[name] ? 'error' : ''}
    help={errors && errors[name]?.message}
    labelCol={{ span: 24 }}
  >
    <Controller
      render={({ onChange, value }) => (
        <Radio.Group
          onChange={(event: RadioChangeEvent) => {
            onChange(event.target.value === '' ? defaultValue : event.target.value);
          }}
          value={value ?? defaultValue}
          defaultValue={defaultValue}
        >
          {radioOptions.map((radioOption) => (
            <Radio key={radioOption.value} value={radioOption.value}>
              {radioOption.label}
            </Radio>
          ))}
        </Radio.Group>
      )}
      name={name}
      control={control}
    />
  </FormItem>
);
